module.exports = __webpack_public_path__ + "img/tpc-posters-1.0258def4.jpg";